import axios from 'axios';

import PrestadorTabla from '../types/PrestadorTabla';


async function GuardarPrestador(prmPrestador: PrestadorTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_prestador"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "prestador": {
                "id": prmPrestador.id,
                "cuit": prmPrestador.cuit,
                "razonsocial": prmPrestador.razonsocial,
                "nombrecomercial": prmPrestador.nombrecomercial,
                "domicilio": prmPrestador.domicilio,
                "telefono": prmPrestador.telefono,
                "whatsapp": prmPrestador.whatsapp,
                "email": prmPrestador.email,
                "sitioweb": prmPrestador.sitioweb,
                "instagram": prmPrestador.instagram,
                "facebook": prmPrestador.facebook,
                "youtube": prmPrestador.youtube,
                "tiktok": prmPrestador.tiktok,
                "linkedin": prmPrestador.linkedin,
                "gpslat": prmPrestador.gpslat,
                "gpslon": prmPrestador.gpslon,
                "idrubro": prmPrestador.idrubro,
                "habilitado": prmPrestador.habilitado,
                "fch_modi": prmPrestador.fecha_modificacion,
                "dado_baja": prmPrestador.dado_de_baja,
                "fch_baja": prmPrestador.fecha_baja,
                "idpais": prmPrestador.idpais,
                "idprovincia": prmPrestador.idprovincia,
                "idlocalidad": prmPrestador.idlocalidad,
                "logo_big": prmPrestador.logo_big,
                "logo_small": prmPrestador.logo_small,
                "observaciones": prmPrestador.observaciones,
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarPrestador;